// TODO: duplicate code with src/lib/types/inventory-types.ts how to share files with frontend and backend?

class TransactionAmount {
    values: Map<string, number>;

    constructor(values: Map<string, number>) {
        this.values = values;
    }

    inverted(): TransactionAmount {
        const invertedValues = new Map<string, number>();
        this.values.forEach((value, key) => {
            invertedValues.set(key, -value);
        });
        return new TransactionAmount(invertedValues);
    }

    toJSON() {
        return Object.fromEntries(this.values);
    }

    static fromJSON(json: any) {
        return new TransactionAmount(new Map(Object.entries(json)));
    }
}

export default TransactionAmount;


export enum DeliveryMethod {
    VIRTUAL_PRODUCT = 'virtual_product', // unlimited inventory
    DIGITAL_PRODUCT = 'digital_product', 
    PHYSICAL_PRODUCT = 'physical_product'
}

export class ProductInventoryItem {
    constructor(
        public instanceId: string,
        public amount: number,
        public productTypeId: string,
        public deliveryMethod: DeliveryMethod,
        public instanceData: Record<string, any>,
        public createdDate: Date,
    ) {}

    toJSON(): Record<string, any> {
        return {
            instanceId: this.instanceId,
            amount: this.amount,
            productTypeId: this.productTypeId,
            deliveryMethod: this.deliveryMethod,
            instanceData: this.instanceData,
            createdDate: this.createdDate.toISOString(),
        };
    }

    static fromJSON(json: Record<string, any>): ProductInventoryItem {
        return new ProductInventoryItem(
            json.instanceId,
            json.amount,
            json.productTypeId,
            json.deliveryMethod as DeliveryMethod,
            json.instanceData,
            new Date(json.createdDate),
        );
    }
}

export enum OrderStatus {
    ORDERED = 'ordered',
    SENT = 'sent',
    CANCELLED = 'cancelled'
}

export class OrderItem {
    constructor(
        public instanceId: string,
        public createdDate: Date,
        public userId: string,
        public name: string,
        public surname: string,
        public address: string,
        public email: string,
        public status: OrderStatus,
        public transactionId: string,
        public productInventoryItem: ProductInventoryItem
    ) {}

    toJSON(): Record<string, any> {
        return {
            instanceId: this.instanceId,
            createdDate: this.createdDate.toISOString(),
            userId: this.userId,
            name: this.name,
            surname: this.surname,
            address: this.address,
            email: this.email,
            status: this.status,
            transactionId: this.transactionId,
            productInventoryItem: this.productInventoryItem.toJSON()
        };
    }

    static fromJSON(json: Record<string, any>): OrderItem {
        return new OrderItem(
            json.instanceId,
            new Date(json.createdDate),
            json.userId,
            json.name,
            json.surname,
            json.address,
            json.email,
            json.status as OrderStatus,
            json.transactionId,
            ProductInventoryItem.fromJSON(json.productInventoryItem)
        );
    }
}

export class ProductItem {
    id: string;
    name: string;
    price: TransactionAmount;
    type: string; // values defined ProductType = permanent | consumable
    deliveryMethod: string; // values defined DeliveryMethod = virtual_product | digital_product | physical_product
    numberInStock: number;
    isAmbassador: boolean;
    isPremium: boolean;

    constructor(id: string, name: string, price: TransactionAmount, type: string, deliveryMethod: string, numberInStock: number = 0, isAmbassador: boolean = false, isPremium: boolean = false) {
        this.id = id;
        this.name = name;
        this.price = price;
        this.type = type;
        this.deliveryMethod = deliveryMethod;
        this.numberInStock = numberInStock;
        this.isAmbassador = isAmbassador;
        this.isPremium = isPremium;
    }

    toJSON() {
        return {
            id: this.id,
            name: this.name,
            price: this.price.toJSON(),
            type: this.type,
            deliveryMethod: this.deliveryMethod,
            numberInStock: this.numberInStock,
            isAmbassador: this.isAmbassador,
            isPremium: this.isPremium,
        };
    }

    static fromJSON(json: any) {
        return new ProductItem(
            json.id,
            json.name,
            TransactionAmount.fromJSON(json.price),
            json.type,
            json.deliveryMethod || 'virtual_product',
            json.numberInStock || 0,
            json.isAmbassador || false,
            json.isPremium || false,
        );
    }
}